<ion-toolbar gaCategory="header_menu" [ngClass]="{ 'platform-desktop': platform.isDesktop() }">
  <ion-item class="ion-align-items-center" lines="none">
    <div class="white-logo"></div>
    <div class="org-selection" slot="end" *ngIf="isInternalUser">
      <ng-select [items]="orgs$ | async" bindLabel="name" [(ngModel)]="selectecOrg" [loading]="orgLoading"
        [typeahead]="orgTermInput$" [appendTo]="'body'" (change)="orgChanged($event)" class="ng-select-org">
      </ng-select>
    </div>
    <ion-menu-button slot="end" *ngIf="!platform.isDesktop()" class="menu-button"></ion-menu-button>
    <ion-avatar slot="end" (click)="toggleProfile(true, $event)" id="header-avatar" *ngIf="platform.isDesktop()">
      <ion-icon name="person-circle-outline">
        <ion-popover reference="event" alignment="center" showBackdrop="false" #profilePopover>
          <ng-template>
            <ion-item gaEvent="view_profile" (click)="viewProfile()">
              <ion-label>{{ "commons.header.myProfile" | translate }}</ion-label>
            </ion-item>
            <ion-item>
              <ion-label gaEvent="user_logout" (click)="logout()">{{ "commons.header.logOut" | translate }}</ion-label>
            </ion-item>
          </ng-template>
        </ion-popover>
      </ion-icon>
    </ion-avatar>
  </ion-item>
</ion-toolbar>